// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"5618f3fe","371":"d32cad28","408":"622ce58c","584":"00f15020","955":"55141762"}[chunkId] + ".chunk.js";
};